// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .sbscr .range-ruler {\n    display: flex;\n    justify-content: space-between;\n    margin: 0 -1px 0 0;\n    opacity: 0.6;\n  }\n  .root .sbscr .range-ruler__mark {\n    width: 1px;\n    height: 6px;\n    background-color: var(--secondary-bg-text-color);\n  }\n  .root .sbscr .range-ruler__label {\n    font-size: 13px;\n    position: absolute;\n    bottom: -4px;\n    transform: translate(-50%, 100%);\n  }\n", ""]);
// Exports
module.exports = exports;
